import { defineComponent, h } from "vue";
import ProductHeader from "../../components/ProductHeader/ProductHeader.mjs";
import "core-js/modules/es.array.push.js";
import { HANDLE_BADGE_CLICK, METRICS_CLICK, OPEN_PREORDER_MODAL, HANDLE_REVIEW_SUMMARY_CLICK } from "../../store/constants.mjs";
import "bezier-easing";
import "js-cookie";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import "@rei/cedar";
import "@rei/spinner";
import "@rei/cdr-tokens";
/* empty css                                                              */
/* empty css                                          */
import "../../components/MediaCenter/MediaCenterHeroImage/MediaCenterHeroImage.mjs";
/* empty css                                                                       */
/* empty css                                  */
/* empty css                                                             */
import "@rei/session";
const HeaderContainer = defineComponent({
  name: "HeaderContainer",
  render() {
    const { getters, dispatch } = this.$store;
    return h(ProductHeader, {
      ...getters.productHeaderProps,
      onBadgeClick: (data) => dispatch(HANDLE_BADGE_CLICK, data),
      onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
      onPreorderBannerClick: () => dispatch(OPEN_PREORDER_MODAL),
      onScrollToReviews: () => dispatch(HANDLE_REVIEW_SUMMARY_CLICK)
    });
  }
});
export {
  HeaderContainer as default
};
//# sourceMappingURL=HeaderContainer.mjs.map
